import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Action } from '../../../models/Action';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionService } from '../../../services/entities/action.service';
import { Gama } from '../../../models/Gama';
import { GamaService } from '../../../services/entities/gama.service';
import { FirebaseService } from '../../../services/auth/firebase.service';
import { WorkerService } from '../../../services/entities/worker.service';
import { Worker } from '../../../models/Worker';

const ACTION_TYPES = ['view', 'edit', 'create']

@Component({
  selector: 'app-edit-action',
  templateUrl: './edit-action.component.html',
  styleUrl: './edit-action.component.scss'
})
export class EditActionComponent implements OnInit{
  @ViewChild('gama_input') gama_input!: ElementRef;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private formBuilder: FormBuilder,
              private actionService: ActionService,
              private gamaService: GamaService,
              private workerService: WorkerService,
              private firebaseService: FirebaseService){}

  // Interval Vars
  focus_interval: any

  //Action Types Vars
  action: string = 'edit'

  //Error Vars
  message = {
    status: '',
    text: ''
  }

  actual_step: number = 1

  workers: Worker[] = []

  target_gama: Gama = {id: '', order_id: '', index: 0, active: true, designations: [], s_c_one: '', affaire: '', treatment: '', operations: [], materials: [], actions: []}
  
  //Action Vars
  form_in_progress: boolean = false
  action_form!: FormGroup

  ngOnInit() {
    this.route.params.subscribe(async params => {
      this.action = params['action']

      this.initForm()
      this.workers = (await this.workerService.getWorkers().toPromise())!!

      if(!this.action || !ACTION_TYPES.includes(this.action)) this.router.navigate(['/orders'])
      
      switch(this.action){
        case 'create':
          this.initForm()
        break
      }
    });
  
    this.startFocusBucle()
  }

  ngOnDestroy(): void {
    if (this.focus_interval) {
      clearInterval(this.focus_interval);
    }
  }

  focusOnInput(){
    if(this.actual_step === 1) this.gama_input.nativeElement.focus()
  }

  startFocusBucle(){
    if(this.actual_step === 1){
      this.focus_interval = setInterval(() => {
        this.focusOnInput()
      }, 1000)
    }
  }

  fixPistolInput(){
    this.action_form.patchValue({gama: {id: this.action_form.value.gama.id.replaceAll("'", '-')}})
    this.checkGamaIdLength()
  }

  checkGamaIdLength(){
    if(this.action_form.value.gama.id.length !== 36) this.message = {status: 'error', text: 'El ID de la gama debe tener 36 caracteres.'}
    else this.setGama()
  }

  setGama(){
    console.log("this.action_form.value.gama.id", this.action_form.value.gama.id)
    this.gamaService.getGamaById(this.action_form.value.gama.id).subscribe(
      gama => {
        this.target_gama = gama
        console.log("target_gama", this.target_gama)
        if(this.target_gama && this.target_gama.id) this.actual_step = 2
        else this.message = {status: 'error', text: 'No se ha encontrado la gama.'}
      },
      error =>{
        console.error('Error getting gama:', error)
        this.message = {status: 'error', text: 'No se ha encontrado la gama.'}
      }
    )
  }

  setWorker(worker_id: string){
    this.action_form.patchValue({worker: {id: worker_id}})
    this.registerAction()
  }

  setAction(type: 'start' | 'end'){
    this.action_form.patchValue({type: type})
    this.actual_step += 1
  }

  async registerAction(){
    try{
      this.actionService.createAction(this.action_form.value).subscribe(
        (action_aux: Action) => {
          if(this.firebaseService.user.role === 'administrator') this.router.navigate(['/gamas/view/' + this.action_form.value.gama.id])
            this.message = {status: 'success', text: 'Acción registrada correctamente.'}
          window.location.reload()
        },
        (error) => {
          this.message = {status: 'error', text: 'Error al registrar la acción.'}
          console.error('Error creating action:', error)
        }
      )
    }
    catch(error){
      console.error('Action not registered. Gama not found.')
      this.message = {status: 'error', text: 'Error al registrar la acción. La gama no existe'}
    }
  }

  initForm() {
    this.action_form = this.formBuilder.group(
      {
        type: ['start'],
        worker: this.formBuilder.group({
          id: [''],
        }),
        gama: this.formBuilder.group({
          id: [''],
        }),
      }
    )
  }

  resetForm(){
    this.action_form.reset()
    this.action_form.patchValue({type: 'start'})
  }
}
